import Icon from '@ant-design/icons';
import React from 'react';

const PlantSvg = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M9.784 4.642c0 1.826-1.781 3.307-1.781 3.307s-1.78-1.48-1.78-3.307 1.78-3.309 1.78-3.309 1.78 1.482 1.78 3.309zM12.85 12.847C11.009 14.692 8 14.664 8 14.664s-.028-3.012 1.813-4.854c1.841-1.841 4.853-1.813 4.853-1.813s.025 3.014-1.816 4.85z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M3.146 12.847C4.988 14.692 8 14.664 8 14.664s.028-3.012-1.814-4.854C4.345 7.97 1.333 7.997 1.333 7.997s-.028 3.014 1.813 4.85z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.003 7.95v6.714"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PlantIcon = (props: any) => <Icon component={PlantSvg} {...props} />;

export default PlantIcon;
